import statusesEdit from '@/views/statuses/edit'
import statusesList from '@/views/statuses/list'

export default [
  {
    path: '/estados',
    name: 'statusesList',
    component: statusesList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'statuses',
      heading: 'menu.statuses',
      auth: true,
      roles: [
        {
          edit: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/estados/novo',
    name: 'statusesCreate',
    component: statusesEdit,
    meta: {
      layout: 'sidebar',
      base: 'statuses',
      heading: 'menu.statuses',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/estados/:id/editar',
    name: 'statusesUpdate',
    component: statusesEdit,
    meta: {
      layout: 'sidebar',
      base: 'statuses',
      heading: 'menu.statuses',
      auth: true,
      roles: ['super-admin']
    }
  }
]
